module.exports = __webpack_public_path__ + "img/nico.6c57d8af.jpg";